import { request } from '@/api/httpClient'
import { RequestType } from '@/enums'

export async function customerUpdateCompanySettings(showSizes, showDesignNames) {
  return request({
    method: 'customer/UpdateCompanySettings',
    payload: {
      ShowconsumerSizes: showSizes,
      ShowDesignNames: showDesignNames
    }
  })
}

export async function customerGetCompanySettings() {
  return request({
    method: 'customer/GetCompanySettings'
  })
}
export async function customerGetProcessingLevels() {
  return request({
    method: 'customer/GetProcessingLevels'
  })
}

export async function customerUpdateProductDefault(payload) {
  return request({
    method: 'customer/UpdateProductDefault',
    payload
  })
}

export async function customerGetProductDefaultsWithDetails(payload) {
  return request({
    method: 'customer/GetProductDefaultsWithDetails',
    payload
  })
}

export async function customerGetProductsWithDefaults(datasetId) {
  return request({
    method: 'customer/GetProductsWithDefaults',
    payload: {
      DatasetId: datasetId
    }
  })
}

export async function customerGetExtraItemOptions(itemId) {
  return request({
    method: 'customer/GetExtraItemOptions',
    payload: { itemId }
  })
}

export async function customerUpdateExtraItemOptions(params) {
  return request({
    method: 'customer/UpdateExtraItemOptions',
    payload: { Options: params }
  })
}

export async function customerUpdateExtraItems(params) {
  return request({
    method: 'customer/UpdateExtraItems',
    payload: { Items: params }
  })
}

export async function customerUpdateExtraItemGroups(params) {
  return request({
    method: 'customer/UpdateExtraItemGroups',
    payload: { Groups: params }
  })
}

export async function customerGetAllExtraItems() {
  return request({
    method: 'customer/GetAllExtraItems'
  })
}

export async function customerGetExtraItemGroups() {
  return request({
    method: 'customer/GetExtraItemGroups'
  })
}

export async function customerGetExtraItems(GroupId) {
  return request({
    method: 'customer/GetExtraItems',
    payload: { GroupId }
  })
}

export async function customerGet(customerId, staffLogin) {
  let options = {}
  if (staffLogin) {
    options = {
      CustomerId: parseInt(customerId, 10)
    }
  }

  return request({
    method: 'customer/Get',
    payload: options
  })
}

export async function customerGetGuest() {
  return request({
    method: 'customer/GetForGuest'
  })
}

export async function customerUpdateDeliveryDays(customer, staffLogin) {
  const Customer = {
    Delivery: customer.delivery
  }
  if (staffLogin) {
    Customer.CustomerId = customer.customerId
  }

  return request({
    method: 'customer/Update',
    payload: Customer
  })
}

export async function customerUpdateUsers(customer, staffLogin, userIdsToUpdate) {
  let usersToUpdate

  if (!userIdsToUpdate) usersToUpdate = customer.users.filter((x) => !x.id)
  else usersToUpdate = customer.users.filter((x) => userIdsToUpdate.find((y) => y === x.id))

  const Users = usersToUpdate.map((user) => ({
    ...user,
    licenseStatusType: Number(user.licenseStatusType),
    processingLevelId: Number(user.processingLevelId)
  }))
  const Customer = {
    Users
  }
  if (staffLogin) {
    Customer.CustomerId = customer.customerId
  }

  return request({
    method: 'customer/Update',
    payload: Customer
  })
}

export async function customerUpdateAddresses(customer, staffLogin) {
  const Customer = {
    Addresses: customer.addresses
  }
  if (staffLogin) {
    Customer.CustomerId = customer.customerId
  }

  return request({
    method: 'customer/Update',
    payload: Customer
  })
}

export async function customerUpdateVendorAddress(customer, staffLogin) {
  const Customer = {
    Addresses: customer.addresses
  }
  if (staffLogin) {
    Customer.CustomerId = customer.customerId
  }

  await request({
    method: 'customer/Update',
    payload: Customer
  })

  let params = {}

  if (staffLogin) {
    params = {
      CustomerId: customer.customerId
    }
  }

  const { addresses } = await request({
    method: 'customer/Get',
    payload: params
  })

  return addresses
}

export async function customerCreate(customer) {
  const Customer = {
    Name: customer.name,
    SalesSector: customer.salesSector,
    Email: customer.email,
    Phone: customer.phone,
    Web: customer.web,
    DefaultTaxId: customer.defaultTaxId,
    Branches: customer.branches,
    ExtruderLevel: customer.extruderLevel
  }

  const { id } = await request({
    method: 'customer/Create',
    payload: Customer
  })
  return id
}

export async function customerListContacts() {
  return request({
    method: 'customer/ListContacts'
  })
}

export async function customerGetFinancialGroups(datasetId) {
  return request({
    method: 'customer/GetFinancialGroups',
    payload: {
      DatasetId: datasetId
    }
  })
}

export async function customerGetContact(ContactId) {
  return request({
    method: 'customer/GetContact',
    payload: {
      ContactId: parseInt(ContactId, 10)
    }
  })
}

export async function customerEditContact(Contact) {
  const user = Contact
  user.licenseStatusType = Number(Contact.licenseStatusType)

  return request({
    method: 'customer/EditContact',
    payload: user
  })
}

export async function customerCreateContact(Contact) {
  return request({
    method: 'customer/CreateContact',
    payload: Contact
  })
}

export async function customerUpdateCommerceIntegrationSettings(eCommerceIntegrationSettings, customerId) {
  const Customer = {
    ECommerceIntegration: {
      Alias: eCommerceIntegrationSettings.alias,
      WebAddress: eCommerceIntegrationSettings.webAddress,
      Email: eCommerceIntegrationSettings.email,
      mobilePhone: eCommerceIntegrationSettings.mobilePhone,
      privacyPolicyDocumentId: eCommerceIntegrationSettings.privacyPolicyDocumentId,
      addressId: eCommerceIntegrationSettings.addressId,
      companyRegNumber: eCommerceIntegrationSettings.companyRegNumber,
      fensaRegistrationNumber: eCommerceIntegrationSettings.fensaRegistrationNumber,
      vatRegistrationNumber: eCommerceIntegrationSettings.vatRegistrationNumber,
      priceDisplayMode: Number(eCommerceIntegrationSettings.priceDisplayMode)
    },
    CustomerId: customerId
  }
  return request({
    method: 'customer/Update',
    payload: Customer
  })
}

export async function customerUpdateFinancialSettings({ vatEnabled, taxValue, fittingRate }) {
  const Customer = {
    Financial: {
      vatEnabled: Boolean(vatEnabled),
      taxValue: Number(taxValue),
      fittingRate: Number(fittingRate)
    }
  }
  await request({
    method: 'customer/Update',
    payload: Customer
  })
}

export async function customerGetProductOverrides() {
  return request({
    method: 'customer/GetProductOverrides'
  })
}

export async function customerGetAllProductsWithOverrides(customerId) {
  return request({
    method: 'customer/GetAllProductsWithOverrides',
    payload: {
      CustomerId: customerId !== undefined ? Number(customerId) : undefined
    }
  })
}

export async function customerUpdateProductOverrides(overrides, customerId) {
  return request({
    method: 'customer/UpdateProductOverrides',
    payload: {
      CustomerId: customerId,
      Overrides: overrides
    }
  })
}

export async function customerUploadDocumentWithUrl(document) {
  const { id } = await request({
    method: 'customer/UploadDocumentWithUrl',
    payload: {
      Id: document.id,
      Type: Number(document.type),
      CategoryId: document.categoryId,
      Name: document.name,
      OverwriteCurrentSingleDocument: true,
      Url: document.url,
      VideoType: document.videoType,
      DealerNetworkPartnerOnly: document.DealerNetworkPartnerOnly,
      ImageBlob: document.ImageBlob
    }
  })
  return id
}

export async function customerUpdateRaw(customer) {
  return request({
    method: 'customer/Update',
    payload: customer
  })
}

export async function customerUpdateCustomerRequoteDetails(customer) {
  return request({
    method: 'customer/UpdateCustomerRequoteDetails',
    payload: {
      CustomerId: customer.customerId,
      RequoteEmail: customer.requoteEmail,
      RequoteEmailSubject: customer.requoteEmailSubject,
      RequoteEmailBodyText: customer.requoteEmailBodyText
    }
  })
}

export async function customerListTicketContacts() {
  return request({
    method: 'customer/ListTicketContacts'
  })
}

export async function customerResendActivationEmail(contactId) {
  return request({
    method: 'Customer/ResendActivationEmail',
    payload: {
      ContactId: contactId
    }
  })
}

export async function customerCreateBranch(branch) {
  const Branch = {
    Name: branch.name,
    Email: branch.email,
    Phone: branch.phone,
    Address: {
      Town: branch.town,
      County: branch.county
    }
  }
  return request({
    method: 'Customer/CreateBranch',
    payload: Branch
  })
}

export async function customerListBranchCompanies(limit, offset, searchName, contractId) {
  const response = await request({
    method: 'Customer/ListBranchCompanies',
    payload: {
      limit,
      offset,
      searchName,
      ContractIDForDistance: contractId
    }
  })
  const branches = response.availableBranches.map((branch) => ({
    ...branch,
    url: `/branch/${branch.id}/details`
  }))
  return { branches }
}

export async function customerUpdateBranch(branch) {
  await request({
    method: 'Customer/UpdateBranch',
    payload: {
      Id: parseInt(branch.id, 10),
      Name: branch.name,
      Email: branch.email,
      Phone: branch.phone
    }
  })
}

export async function customerGetCompany(companyId) {
  return request({
    method: 'Customer/GetCompany',
    payload: {
      CompanyId: parseInt(companyId, 10)
    }
  })
}

export async function customerUpdateBranchAddress(address) {
  return request({
    method: 'Customer/UpdateBranch',
    payload: {
      Id: parseInt(address.branchId, 10),
      Address: {
        Line1: address.line1,
        Line2: address.line2,
        Line3: address.line3,
        Town: address.town,
        County: address.county,
        Code: address.code,
        Iso: address.iso,
        IsPrimary: address.isPrimary
      }
    }
  })
}

export async function customerGetCustomQuoteStatuses(CompanyId) {
  const { stages } = await request({
    method: 'Customer/GetCustomQuoteStages',
    payload: {
      CompanyId
    }
  })
  return stages
}

export async function customerUpdateCustomQuoteStage(stages) {
  return request({
    method: 'customer/UpdateCustomQuoteStage',
    payload: {
      Stages: stages
    }
  })
}

export async function customerListOrganisationContacts(role) {
  return request({
    method: 'customer/ListOrganisationContacts',
    payload: { role }
  })
}

export async function customerGetAccountSettings() {
  return request({
    method: 'customer/GetAccountSettings'
  })
}

export async function customerUpdateBrandedFabricator({ customerId, active, supplyUntil }) {
  return request({
    method: 'customer/updateBrandedFabricator',
    payload: {
      CustomerId: customerId,
      Active: active,
      SupplyUntil: supplyUntil,
      IndefiniteSupply: !supplyUntil
    }
  })
}

export async function customerListTradeAccountApplications(query) {
  return request({
    method: 'customer/ListTradeAccountApplications',
    payload: query
  })
}

export async function customerProcessTradeAccountApplication(Id, Status) {
  return request({
    method: 'customer/ProcessTradeAccountApplication',
    payload: {
      Id,
      Status
    }
  })
}

export async function customerResendVerificationEmail(ApplicationId) {
  return request({
    method: 'customer/ResendVerificationEmail',
    payload: { ApplicationId }
  })
}

export async function customerUpdateCompanyIssuePresent({ ShowIssuePresentWarning, IssuePresentWarning }) {
  return request({
    method: 'customer/UpdateCompanyIssuePresent',
    payload: { ShowIssuePresentWarning, IssuePresentWarning }
  })
}

export async function customerGetCompanyIssuePresent() {
  return request({
    method: 'customer/GetCompanyIssuePresent'
  })
}

export async function customerGetFinancialCategories() {
  return request({
    method: 'customer/FinancialCategories',
    requestType: RequestType.GET
  })
}

export async function customerUpdateFinancialCategories(payload) {
  return request({
    method: 'customer/UpdateFinancialCategories',
    payload: {
      FinancialCategoryDetails: payload
    }
  })
}

export async function customerCreateTradeAccountApplication(register) {
  return request({
    method: 'customer/CreateTradeAccountApplication',
    payload: register
  })
}

export async function customerVerifyEmail(VerificationCode) {
  return request({
    method: 'customer/VerifyEmail',
    payload: { VerificationCode }
  })
}

export async function customerGetCatalogueProducts({ datasetId }) {
  return request({
    method: `customer/GetCatalogueProducts?DatasetId=${datasetId}`,
    requestType: RequestType.GET
  })
}

export async function customerGetCatalogueProductsWithClearances(datasetId) {
  return request({
    method: `customer/GetCatalogueProductsWithClearances?DatasetId=${datasetId}`,
    requestType: RequestType.GET
  })
}

export async function customerUpdateCatalogueGlassClearances({ DatasetId, GlassClearances }) {
  return request({
    method: 'customer/UpdateCatalogueGlassClearances',
    payload: {
      DatasetId,
      GlassClearances
    }
  })
}

export async function customerGetSimpleProductFinancials({ datasetId, productId }) {
  return request({
    method: `customer/GetSimpleProductFinancials?DatasetId=${datasetId}&ProductId=${productId}`,
    requestType: RequestType.GET
  })
}

export async function customerUpdateSimpleProductFinancials(payload) {
  return request({
    method: 'customer/UpdateSimpleProductFinancials',
    payload
  })
}
export async function customerGetSimpleProducts({ datasetId, typeId }) {
  return request({
    method: `customer/GetSimpleProducts?DatasetId=${datasetId}&TypeId=${typeId}`,
    requestType: RequestType.GET
  })
}

export async function customerGetGlassFinancials({ datasetId, productId }) {
  return request({
    method: `customer/GetGlassFinancials?DatasetId=${datasetId}&ProductId=${productId}`,
    requestType: RequestType.GET
  })
}

export async function customerGetGlassDecorativeFinancials({ datasetId, productId }) {
  return request({
    method: `customer/GetGlassDecorativeFinancials?DatasetId=${datasetId}&ProductId=${productId}`,
    requestType: RequestType.GET
  })
}

export async function customerGetSlabFinancials({ datasetId, productId }) {
  return request({
    method: `customer/GetSlabFinancials?DatasetId=${datasetId}&ProductId=${productId}`,
    requestType: RequestType.GET
  })
}

export async function customerGetPanelFinancials({ datasetId, productId }) {
  return request({
    method: `customer/GetPanelFinancials?DatasetId=${datasetId}&ProductId=${productId}`,
    requestType: RequestType.GET
  })
}

export async function customerUpdatePanelFinancials(payload) {
  return request({
    method: 'customer/UpdatePanelFinancials',
    payload
  })
}

export async function customerGetLabourFinancial({ datasetId }) {
  return request({
    method: `customer/GetLabourFinancial?DatasetId=${datasetId}`,
    requestType: RequestType.GET
  })
}

export async function customerUpdateLabourFinancial(payload) {
  return request({
    method: 'customer/UpdateLabourFinancial',
    payload
  })
}

export async function customerGetLabourUnits({ datasetId, productId }) {
  return request({
    method: `customer/GetLabourUnits?DatasetId=${datasetId}&ProductId=${productId}`,
    requestType: RequestType.GET
  })
}

export async function customerUpdateLabourUnits(payload) {
  return request({
    method: 'customer/UpdateLabourUnits',
    payload
  })
}

export async function customerUpdateGlassFinancials(payload) {
  return request({
    method: 'customer/UpdateGlassFinancials',
    payload
  })
}

export async function customerUpdateGlassDecorativeFinancials(payload) {
  return request({
    method: 'customer/UpdateGlassDecorativeFinancials',
    payload
  })
}

export async function customerUpdateSlabFinancials(payload) {
  return request({
    method: 'customer/UpdateSlabFinancials',
    payload
  })
}

export async function customerGetCatalogueProductsForOverlaps({ datasetId }) {
  return request({
    method: `customer/GetCatalogueProductsForOverlaps?DatasetId=${datasetId}`,
    requestType: RequestType.GET
  })
}

export async function customerGetCatalogueOptionsForOverlaps({ datasetId, productId }) {
  return request({
    method: `customer/GetCatalogueOptionsForOverlaps?DatasetId=${datasetId}&ProductId=${productId}`,
    requestType: RequestType.GET
  })
}

export async function customerUpdateCatalogueSashOverlaps(payload) {
  return request({
    method: 'customer/UpdateCatalogueSashOverlaps',
    payload
  })
}

export async function customerUploadDocumentForm(newDocument) {
  return request({
    method: 'customer/UploadDocumentForm',
    payload: newDocument
  })
}

export async function customerGetMpcSpecification(payload) {
  return request({
    method: 'customer/GetMpcSpecification',
    payload
  })
}

export async function customerUpdateMpcSpecification(payload) {
  return request({
    method: 'customer/UpdateMpcSpecification',
    payload
  })
}

export async function customerGetMpcProductDefaults(payload) {
  return request({
    method: 'customer/GetMpcProductDefaults',
    payload
  })
}

export async function customerUpdateMpcProductDefaults(payload) {
  return request({
    method: 'customer/UpdateMpcProductDefaults',
    payload
  })
}

export async function customerSyncSpecifications(payload) {
  return request({
    method: 'customer/SyncSpecifications',
    payload
  })
}
